import React, { useState } from 'react';

import { Alert } from 'antd';
import Axios from 'axios';
import { Formik, Field } from 'formik';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
// import * as Yup from "yup";
import NwDrawer from '@components/Gui/NwDrawer';

import { NWBankAccountsSelector } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const EditBankDetailsDrawer = (props) => {
    const { onClose, data } = props;
    const [touchForm, setTouchForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const initialValues = {
        BankAccountID: data.BankAccountID ? data.BankAccountID : null,
    };

    const saveBankAccount = async (values, setSubmitting) => {
        setSubmitting(true);
        setErrorMessage(null);
        try {
            await Axios.put(`/invoices/bankaccount`, {
                InvoiceID: data.ID,
                BankAccountID: values.BankAccountID,
            });
            onClose();
        } catch (e) {
            setErrorMessage(`Error changing bank account: ${e?.message || 'unknown error'}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Change Bank Details">
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    saveBankAccount(values, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWBankAccountsSelector}
                            label="Bank Account"
                            name="BankAccountID"
                            value={values.BankAccountID}
                        />
                        {errorMessage && <Alert style={{ margin: '1rem 0' }} message={errorMessage} type="error" />}
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default EditBankDetailsDrawer;
